function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueLodash = t() : e.VueLodash = t();
}(this, function () {
  return function (e) {
    var t = {};

    function o(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
    }

    return o.m = e, o.c = t, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        o.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "dist", o(o.s = 0);
  }([function (e, t, o) {
    var n;

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    !function () {
      function o(e, t) {
        var n, r, u;
        o.installed || (o.installed = !0, t && t.lodash ? (e.lodash = t.lodash, e._ = t.lodash, Object.defineProperties(e.prototype, {
          lodash: {
            get: function get() {
              return t.lodash;
            }
          },
          _: {
            get: function get() {
              return t.lodash;
            }
          }
        }), t.name && (e[t.name] = t.lodash, Object.defineProperties(e.prototype, (n = {}, r = t.name, u = {
          get: function get() {
            return t.lodash;
          }
        }, r in n ? Object.defineProperty(n, r, {
          value: u,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : n[r] = u, n)))) : console.error("You have to install lodash"));
      }

      "object" == r(t) ? e.exports = o : void 0 === (n = function () {
        return o;
      }.apply(t, [])) || (e.exports = n);
    }();
  }]);
});